import { Nullable } from "./Extensions";
import { NAMESPACE } from "./_Namespace";

export class PropertyChange<TValue>
{
    public static classNamespace = NAMESPACE + "PropertyChange";
    public static className = "PropertyChange";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    private _currentValue: Nullable<TValue>;
    private _originalValue: Nullable<TValue>;

    constructor(currentValue: Nullable<TValue>, originalValue: Nullable<TValue>)
    {
        this._currentValue = currentValue;
        this._originalValue = originalValue;
    }

    get currentValue(): Nullable<TValue>
    {
        return this._currentValue;
    }

    get originalValue(): Nullable<TValue>
    {
        return this._originalValue;
    }
}